import { FC } from "react";
import { Box, Skeleton, SxProps, Theme, tooltipClasses, Typography } from "@mui/material";
import { CardCore } from "src/Pages/components/CardCore/CardCore";



import { styled } from '@mui/material/styles';
import { Tooltip, TooltipProps } from '@mui/material';
import { InfoOutlinedIcon } from "../Icons/Icons";


interface ICardsStatics {
  loading?: boolean;
  data: {
    value1: {
      value: string;
      valueSub?: string;
    },
    value2?: {
      value: string;
      valueSub?: string;
    },
    name: string;
    icon?: React.ReactNode;
  };
  sStyle?: SxProps<Theme>;
  small?: boolean;
  tooltip?: string;
  button?: React.ReactNode;
}

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.secondary,
    boxShadow: theme.shadows[4],
    fontSize: 12,
    maxWidth: '220px',
    borderRadius: '8px',
    padding: "8px",
  },
}));

export const CardsStatics: FC<ICardsStatics> = ({ data, sStyle, small, tooltip, button }) => {
  const { icon, value1, value2, name } = data;

  return (
    <CardCore sxStyle={{ margin: 0, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between", ...sStyle }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "18px" }}>
        <Typography
          sx={{
            fontSize: small ? 15 : 17,
            color: "text.secondary",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            // width: "100%",
          }}
        >
          {name}
        </Typography>

        {tooltip && (
          <LightTooltip title={tooltip}>
            <InfoOutlinedIcon sx={{ fontSize: 18, color: "text.secondary", cursor: "pointer" }} />
          </LightTooltip>
        )}

        {button && button}
      </Box>

      <Box sx={{ display: "flex", alignItems: "end", justifyContent: "space-between", }}>
        <Box >
          <Box sx={{ display: "flex", flexDirection: "row", gap: 1, alignItems: "center" }}>
            <Typography sx={{ fontSize: small ? 16 : 18, fontWeight: "bold", }}        >
              {value1.value}
            </Typography>
            {value1.valueSub && (
              <Typography sx={{ fontSize: small ? 12 : 14, color: "text.secondary" }}        >
                {value1.valueSub}
              </Typography>
            )}
          </Box>

          {value2 && (
            <Box sx={{ display: "flex", flexDirection: "row", gap: 1, alignItems: "center" }}>
              <Typography sx={{ fontSize: small ? 13 : 14, color: "text.secondary" }}>
                {value2.value}
              </Typography>
              {value2.valueSub && (
                <Typography sx={{ fontSize: small ? 13 : 14, color: "text.secondary" }}>
                  {value2.valueSub}
                </Typography>
              )}
            </Box>
          )}
        </Box>

        {icon &&
          <Box sx={{
            // padding: "8px",
            // backgroundColor: `#f0f0f0`,
            borderRadius: "50%",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            // border: "1px solid #e0e0e0",
          }}>
            {icon}
          </Box>
        }
      </Box>
    </CardCore>
  );
};
